import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import CardBase from './CardBase';

interface CardCustomProps {
  title: React.ReactNode;
  value?: number | string;
  icon: IconDefinition;
  color: string;
  targetUrl?: string;
}

const CardCustom: React.FC<CardCustomProps> = ({ title, value, icon, color, targetUrl }) => {
  return (
    <CardBase
      title={title}
      badge={value}
      icon={icon}
      color={color}
      targetUrl={targetUrl}
    />
  );
};

export default CardCustom;